// src/components/AppIntroSection.js
import React from "react";
import styles from "../styles/AppIntroSection.module.css";

function AppIntroSection({
  appMainScreen,
  appName,
  appDescription1 = "",
  appSubDescription2 = "",
}) {
  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img
          src={appMainScreen}
          alt={`${appName} 메인 화면`}
          className={styles.appImage}
        />
      </div>
      <div className={styles.textWrapper}>
        <h2 className={styles.title}>{appName}</h2>
        <p className={styles.description}>
          {appName}은 {appDescription1}{" "}
        </p>
        <p className={styles.description}>{appSubDescription2}</p>
      </div>
    </div>
  );
}

export default AppIntroSection;
